// Star Line — GPS Coordinates
// terminal_id keys match Supabase route_points.terminal_id
// All coordinates: [longitude, latitude] — Mapbox format

export const TERMINAL_COORDS: Record<string, { lng: number; lat: number; name: string; district: string }> = {

  // Dhaka
  "33f57dfc-6668-415b-90db-146163fac95c": { lng: 90.4264, lat: 23.7165, name: "ManinkNagar Terminal", district: "Dhaka" },
  "656d8fd7-5f13-4556-ab4d-a55d1d4520e6": { lng: 90.4270, lat: 23.7195, name: "Sayedabad Counter", district: "Dhaka" },
  "7aebb7cd-7c2c-46f4-bcf7-a90f0588c448": { lng: 90.4862, lat: 23.6968, name: "Kazla-Sontek Counter", district: "Dhaka" },
  "72598623-878d-456d-a9b9-876cb0508f78": { lng: 90.3748, lat: 23.8349, name: "Abdullahpur Main Terminal", district: "Dhaka" },
  "b77ba349-d28c-4e91-b6f2-7d89d0a837e6": { lng: 90.4020, lat: 23.8195, name: "Azampur Counter", district: "Dhaka" },
  "228623c0-a119-4a45-85f1-719276687a7c": { lng: 90.3998, lat: 23.8480, name: "Starline Bus Counter - Airport", district: "Dhaka" },
  "b2928790-4b6c-4b1f-ac63-4b599d51c71e": { lng: 90.4382, lat: 23.7528, name: "Banasree Counter", district: "Dhaka" },
  "4f5923cc-2483-4218-a9e6-2c45c941c678": { lng: 90.4318, lat: 23.7742, name: "Madhya Badda Counter", district: "Dhaka" },
  "d10f04b1-6983-4739-a6dd-e401914f3aad": { lng: 90.4750, lat: 23.7095, name: "Demra Staff Quarter Counter", district: "Dhaka" },
  "dfe55485-8361-48db-a513-4b9ad9d0cc6f": { lng: 90.4275, lat: 23.7812, name: "Nadda Counter", district: "Dhaka" },

  // Narayanganj
  "8480baa5-fe28-433f-a802-1aaa89971f1c": { lng: 90.4985, lat: 23.6238, name: "Signboard Counter", district: "Narayanganj" },

  // Comilla
  "18db9111-1e38-40fb-99e8-ba799b736ea6": { lng: 91.1250, lat: 23.4750, name: "Mayami Resort 02 (Break)", district: "Comilla" },
  "9a17e909-8f32-40ea-a6b4-c775e157e248": { lng: 91.2690, lat: 23.1880, name: "Chauddagram Counter", district: "Comilla" },
  "fb9bc431-a989-473c-9b86-b3d864325d1d": { lng: 91.0520, lat: 23.5180, name: "Cheora Counter", district: "Comilla" },

  // Feni
  "8be1a249-0115-4737-a84c-c80c538f6c30": { lng: 91.3852, lat: 23.0012, name: "Starline Special Counter, Mohipal", district: "Feni" },
  "ed71f5ad-e069-4e0a-97c2-ca713bb817f4": { lng: 91.3865, lat: 22.9985, name: "Mohipal Flyover Counter", district: "Feni" },
  "858fa7dc-f7e4-4df4-adfd-7646a0e77695": { lng: 91.3976, lat: 23.0159, name: "Feni Main Terminal", district: "Feni" },
};

// Route polylines keyed by route_id (matches Supabase routes.id)
// Road-snapped geometry fetched from Mapbox Directions API (mapbox/driving)
// overview=full, geometries=geojson — follows actual roads exactly
export const ROUTE_POLYLINES: Record<string, [number, number][]> = {

  // DHK-FENI-01: Maniknagar → Feni
  "1c1892af-325c-4fc7-9223-cc6575b2aae9": [
    [90.426187, 23.716592],
    [90.427163, 23.718515],
    [90.427372, 23.720387],
    [90.428339, 23.720359],
    [90.428478, 23.719608],
    [90.428953, 23.71968],
    [90.428819, 23.72236],
    [90.429295, 23.716511],
    [90.428501, 23.713028],
    [90.428852, 23.712296],
    [90.430727, 23.711203],
    [90.435249, 23.709847],
    [90.470732, 23.69344],
    [90.475481, 23.693245],
    [90.485748, 23.694467],
    [90.485814, 23.694863],
    [90.488271, 23.695153],
    [90.488284, 23.69658],
    [90.487792, 23.697096],
    [90.486909, 23.697099],
    [90.485764, 23.69693],
    [90.487792, 23.697096],
    [90.487883, 23.6966],
    [90.490493, 23.696291],
    [90.490257, 23.695024],
    [90.49272, 23.695366],
    [90.4812, 23.693711],
    [90.48085, 23.693232],
    [90.482089, 23.684097],
    [90.48254, 23.676526],
    [90.489596, 23.65515],
    [90.49361, 23.644659],
    [90.496679, 23.627959],
    [90.49934, 23.624046],
    [90.500067, 23.623882],
    [90.49845, 23.62405],
    [90.499398, 23.622291],
    [90.499907, 23.619653],
    [90.50104, 23.619771],
    [90.500621, 23.622437],
    [90.496664, 23.627804],
    [90.4935, 23.644619],
    [90.489467, 23.65523],
    [90.482443, 23.676502],
    [90.481933, 23.684737],
    [90.48058, 23.692593],
    [90.479198, 23.693424],
    [90.474039, 23.692995],
    [90.469759, 23.693597],
    [90.474679, 23.693167],
    [90.506729, 23.696918],
    [90.512299, 23.699211],
    [90.519843, 23.705243],
    [90.521952, 23.705815],
    [90.524212, 23.705057],
    [90.53924, 23.693112],
    [90.546668, 23.690461],
    [90.553288, 23.683373],
    [90.564702, 23.66214],
    [90.588651, 23.647157],
    [90.594687, 23.636152],
    [90.601587, 23.630349],
    [90.608868, 23.619162],
    [90.609451, 23.617362],
    [90.611013, 23.615127],
    [90.61163, 23.611149],
    [90.616652, 23.600954],
    [90.622318, 23.597943],
    [90.626758, 23.594296],
    [90.640826, 23.579777],
    [90.649381, 23.564727],
    [90.672575, 23.544762],
    [90.688207, 23.530625],
    [90.68958, 23.529861],
    [90.699707, 23.530111],
    [90.717114, 23.531472],
    [90.72408, 23.533705],
    [90.725375, 23.533511],
    [90.732536, 23.530049],
    [90.736668, 23.528667],
    [90.779879, 23.530831],
    [90.786164, 23.531609],
    [90.793374, 23.530601],
    [90.802216, 23.530755],
    [90.806934, 23.53109],
    [90.827197, 23.534962],
    [90.831936, 23.533247],
    [90.845131, 23.522144],
    [90.858589, 23.518197],
    [90.867453, 23.514799],
    [90.879382, 23.507888],
    [90.883645, 23.50601],
    [90.89444, 23.50559],
    [90.907622, 23.506266],
    [90.919675, 23.505049],
    [90.923372, 23.505517],
    [90.931407, 23.505216],
    [90.950063, 23.50095],
    [90.963591, 23.499719],
    [90.981809, 23.495577],
    [91.000088, 23.489474],
    [91.009341, 23.489899],
    [91.017343, 23.487139],
    [91.026747, 23.482717],
    [91.032449, 23.482677],
    [91.035999, 23.481013],
    [91.037777, 23.480736],
    [91.046386, 23.482036],
    [91.053916, 23.482138],
    [91.059049, 23.48151],
    [91.059144, 23.484476],
    [91.059858, 23.48624],
    [91.059146, 23.487199],
    [91.059265, 23.490771],
    [91.060547, 23.493395],
    [91.060195, 23.49491],
    [91.060785, 23.495174],
    [91.06107, 23.499689],
    [91.061391, 23.500465],
    [91.062624, 23.500418],
    [91.062964, 23.502459],
    [91.063495, 23.503035],
    [91.063532, 23.506476],
    [91.064239, 23.509072],
    [91.063352, 23.509369],
    [91.063453, 23.511642],
    [91.062452, 23.513214],
    [91.061246, 23.514096],
    [91.062196, 23.521894],
    [91.053999, 23.522722],
    [91.052931, 23.523094],
    [91.050374, 23.525682],
    [91.05053, 23.526757],
    [91.052549, 23.528244],
    [91.061272, 23.529179],
    [91.06136, 23.526377],
    [91.062229, 23.525769],
    [91.0623, 23.524705],
    [91.061246, 23.514096],
    [91.062452, 23.513214],
    [91.063453, 23.511642],
    [91.063352, 23.509369],
    [91.064239, 23.509072],
    [91.063532, 23.506476],
    [91.063495, 23.503035],
    [91.062964, 23.502459],
    [91.062624, 23.500418],
    [91.061391, 23.500465],
    [91.06107, 23.499689],
    [91.060785, 23.495174],
    [91.060195, 23.49491],
    [91.060547, 23.493395],
    [91.059265, 23.490771],
    [91.059146, 23.487199],
    [91.059858, 23.48624],
    [91.059144, 23.484476],
    [91.059049, 23.48151],
    [91.068398, 23.481296],
    [91.074243, 23.477553],
    [91.07586, 23.477142],
    [91.08516, 23.476825],
    [91.090861, 23.478499],
    [91.094352, 23.477785],
    [91.099793, 23.477588],
    [91.112939, 23.478917],
    [91.121721, 23.478974],
    [91.1279, 23.480146],
    [91.135669, 23.477455],
    [91.136314, 23.47686],
    [91.134199, 23.478079],
    [91.128457, 23.479978],
    [91.128381, 23.47711],
    [91.129256, 23.476169],
    [91.128527, 23.471846],
    [91.126576, 23.470312],
    [91.1264, 23.468753],
    [91.12259, 23.467959],
    [91.124217, 23.461529],
    [91.126442, 23.457385],
    [91.12943, 23.456623],
    [91.131989, 23.457432],
    [91.134692, 23.45743],
    [91.137002, 23.458627],
    [91.142358, 23.458918],
    [91.148108, 23.446932],
    [91.155686, 23.42807],
    [91.157535, 23.426114],
    [91.183265, 23.413425],
    [91.208824, 23.410058],
    [91.211328, 23.409244],
    [91.213045, 23.408077],
    [91.224989, 23.396631],
    [91.240349, 23.377948],
    [91.250025, 23.364069],
    [91.256038, 23.353755],
    [91.264912, 23.341639],
    [91.273717, 23.331887],
    [91.283031, 23.318442],
    [91.286623, 23.30803],
    [91.290185, 23.301157],
    [91.292051, 23.29283],
    [91.294989, 23.284604],
    [91.295976, 23.283074],
    [91.299777, 23.279758],
    [91.306283, 23.266201],
    [91.307979, 23.253132],
    [91.313037, 23.239641],
    [91.313217, 23.231252],
    [91.314267, 23.2259],
    [91.314267, 23.219746],
    [91.315995, 23.213599],
    [91.319485, 23.191279],
    [91.319159, 23.191099],
    [91.316948, 23.193581],
    [91.315673, 23.193719],
    [91.304082, 23.192731],
    [91.301829, 23.193183],
    [91.300289, 23.192677],
    [91.296332, 23.188539],
    [91.295747, 23.18718],
    [91.291741, 23.186745],
    [91.284373, 23.187071],
    [91.284327, 23.185991],
    [91.280921, 23.185919],
    [91.280688, 23.185093],
    [91.279512, 23.184243],
    [91.276021, 23.185045],
    [91.270725, 23.185427],
    [91.270521, 23.184596],
    [91.26928, 23.18389],
    [91.273763, 23.183552],
    [91.274267, 23.185009],
    [91.275844, 23.185065],
    [91.282901, 23.183077],
    [91.283111, 23.17873],
    [91.282723, 23.176436],
    [91.283928, 23.175189],
    [91.282328, 23.170749],
    [91.282584, 23.169026],
    [91.281884, 23.167777],
    [91.290885, 23.168344],
    [91.296569, 23.166326],
    [91.299785, 23.166496],
    [91.313073, 23.167929],
    [91.314046, 23.167628],
    [91.321181, 23.167954],
    [91.321261, 23.17044],
    [91.321853, 23.158757],
    [91.326613, 23.14753],
    [91.32628, 23.13833],
    [91.327794, 23.131376],
    [91.33317, 23.118995],
    [91.359691, 23.072706],
    [91.361658, 23.065844],
    [91.361813, 23.060809],
    [91.365137, 23.048143],
    [91.365832, 23.034584],
    [91.365455, 23.02554],
    [91.366009, 23.023345],
    [91.367374, 23.021469],
    [91.381561, 23.009517],
    [91.37648, 23.009786],
    [91.376373, 23.007523],
    [91.377162, 23.006592],
    [91.377578, 23.004596],
    [91.380411, 23.004882],
    [91.380512, 23.003507],
    [91.381123, 23.00357],
    [91.381979, 23.002727],
    [91.3824, 23.003068],
    [91.38535, 23.002865],
    [91.385553, 23.002314],
    [91.386825, 23.001747],
    [91.385553, 23.002314],
    [91.385394, 23.002856],
    [91.382861, 23.002928],
    [91.38288, 23.003789],
    [91.382035, 23.00386],
    [91.381554, 23.004482],
    [91.380458, 23.00444],
    [91.382279, 23.00841],
    [91.381103, 23.00951],
    [91.379181, 23.009711],
    [91.399302, 23.009679],
    [91.393377, 23.01538],
    [91.394095, 23.016011],
    [91.397581, 23.016677],
    [91.397468, 23.015876],
  ],

  // FENI-DHK-01: Feni → Maniknagar
  "fd5c5ad4-10a5-4174-b1d0-921dcec0770e": [
    [91.397468, 23.015876],
    [91.397581, 23.016677],
    [91.394095, 23.016011],
    [91.393377, 23.01538],
    [91.392598, 23.016071],
    [91.388219, 23.015841],
    [91.3877, 23.015086],
    [91.387639, 23.013514],
    [91.381894, 23.013196],
    [91.382319, 23.009522],
    [91.37648, 23.009786],
    [91.376373, 23.007523],
    [91.377162, 23.006592],
    [91.377578, 23.004596],
    [91.380411, 23.004882],
    [91.380512, 23.003507],
    [91.381123, 23.00357],
    [91.381979, 23.002727],
    [91.3824, 23.003068],
    [91.38535, 23.002865],
    [91.385553, 23.002314],
    [91.386825, 23.001747],
    [91.385553, 23.002314],
    [91.385394, 23.002856],
    [91.3824, 23.003068],
    [91.381979, 23.002727],
    [91.381123, 23.00357],
    [91.380512, 23.003507],
    [91.380411, 23.004882],
    [91.382279, 23.00841],
    [91.381103, 23.00951],
    [91.373411, 23.009878],
    [91.369539, 23.00916],
    [91.371748, 23.012453],
    [91.371255, 23.014964],
    [91.370146, 23.016654],
    [91.370487, 23.018695],
    [91.366948, 23.021727],
    [91.365377, 23.024826],
    [91.365651, 23.034983],
    [91.364842, 23.04918],
    [91.358265, 23.074343],
    [91.340439, 23.106531],
    [91.333035, 23.118975],
    [91.32764, 23.131347],
    [91.326159, 23.138229],
    [91.325952, 23.141626],
    [91.324843, 23.146059],
    [91.32338, 23.149575],
    [91.321575, 23.159424],
    [91.32105, 23.170415],
    [91.319793, 23.176923],
    [91.319783, 23.178619],
    [91.320623, 23.18152],
    [91.320551, 23.18466],
    [91.319809, 23.189449],
    [91.318815, 23.191664],
    [91.316948, 23.193581],
    [91.315673, 23.193719],
    [91.304082, 23.192731],
    [91.301829, 23.193183],
    [91.300289, 23.192677],
    [91.296332, 23.188539],
    [91.295747, 23.18718],
    [91.291741, 23.186745],
    [91.284373, 23.187071],
    [91.284327, 23.185991],
    [91.280921, 23.185919],
    [91.280688, 23.185093],
    [91.279512, 23.184243],
    [91.276021, 23.185045],
    [91.270725, 23.185427],
    [91.270521, 23.184596],
    [91.26928, 23.18389],
    [91.273763, 23.183552],
    [91.274267, 23.185009],
    [91.275683, 23.185071],
    [91.279512, 23.184243],
    [91.280688, 23.185093],
    [91.280921, 23.185919],
    [91.284327, 23.185991],
    [91.284373, 23.187071],
    [91.291741, 23.186745],
    [91.295747, 23.18718],
    [91.296332, 23.188539],
    [91.300289, 23.192677],
    [91.301829, 23.193183],
    [91.304082, 23.192731],
    [91.314045, 23.193825],
    [91.316948, 23.193581],
    [91.316463, 23.19516],
    [91.317139, 23.198079],
    [91.31573, 23.209741],
    [91.315823, 23.213663],
    [91.313713, 23.221406],
    [91.312802, 23.240023],
    [91.306678, 23.255857],
    [91.298259, 23.270952],
    [91.295888, 23.281554],
    [91.291934, 23.292813],
    [91.290239, 23.300625],
    [91.286743, 23.307417],
    [91.283968, 23.316058],
    [91.282324, 23.319415],
    [91.273515, 23.331927],
    [91.264914, 23.341441],
    [91.255692, 23.354007],
    [91.250215, 23.363539],
    [91.240245, 23.377868],
    [91.228524, 23.392123],
    [91.221322, 23.399993],
    [91.212777, 23.408111],
    [91.208888, 23.409913],
    [91.182701, 23.413482],
    [91.17249, 23.418893],
    [91.157501, 23.425966],
    [91.156298, 23.426959],
    [91.155492, 23.428107],
    [91.147871, 23.447164],
    [91.141976, 23.459503],
    [91.13702, 23.475448],
    [91.135622, 23.477324],
    [91.128457, 23.479978],
    [91.128381, 23.47711],
    [91.129256, 23.476169],
    [91.128527, 23.471846],
    [91.129513, 23.472064],
    [91.130449, 23.474898],
    [91.132714, 23.477157],
    [91.132662, 23.478621],
    [91.128457, 23.479978],
    [91.121907, 23.478865],
    [91.112885, 23.478799],
    [91.104668, 23.477764],
    [91.08826, 23.476685],
    [91.082323, 23.476738],
    [91.075287, 23.477077],
    [91.068964, 23.479353],
    [91.053282, 23.482021],
    [91.059049, 23.48151],
    [91.059144, 23.484476],
    [91.059858, 23.48624],
    [91.059146, 23.487199],
    [91.059265, 23.490771],
    [91.060547, 23.493395],
    [91.060195, 23.49491],
    [91.060785, 23.495174],
    [91.06107, 23.499689],
    [91.061391, 23.500465],
    [91.062624, 23.500418],
    [91.062964, 23.502459],
    [91.063495, 23.503035],
    [91.063532, 23.506476],
    [91.064239, 23.509072],
    [91.063352, 23.509369],
    [91.063453, 23.511642],
    [91.062452, 23.513214],
    [91.061246, 23.514096],
    [91.062128, 23.522098],
    [91.052972, 23.523068],
    [91.050374, 23.525682],
    [91.050486, 23.526688],
    [91.052549, 23.528244],
    [91.061272, 23.529179],
    [91.06136, 23.526377],
    [91.062229, 23.525769],
    [91.0623, 23.524705],
    [91.061246, 23.514096],
    [91.062452, 23.513214],
    [91.063453, 23.511642],
    [91.063352, 23.509369],
    [91.064239, 23.509072],
    [91.063532, 23.506476],
    [91.063495, 23.503035],
    [91.062964, 23.502459],
    [91.062624, 23.500418],
    [91.061391, 23.500465],
    [91.06107, 23.499689],
    [91.060785, 23.495174],
    [91.060195, 23.49491],
    [91.060547, 23.493395],
    [91.059265, 23.490771],
    [91.059146, 23.487199],
    [91.059858, 23.48624],
    [91.059144, 23.484476],
    [91.059049, 23.48151],
    [91.068398, 23.481296],
    [91.074243, 23.477553],
    [91.077022, 23.476967],
    [91.074645, 23.477244],
    [91.068964, 23.479353],
    [91.054273, 23.481981],
    [91.044642, 23.48178],
    [91.037845, 23.480584],
    [91.036258, 23.48076],
    [91.032211, 23.482482],
    [91.027384, 23.482396],
    [91.018612, 23.48653],
    [91.0093, 23.489785],
    [90.999937, 23.489381],
    [90.981342, 23.495544],
    [90.975574, 23.494158],
    [90.969969, 23.495935],
    [90.962497, 23.499703],
    [90.958193, 23.500077],
    [90.95411, 23.49952],
    [90.950794, 23.500696],
    [90.930936, 23.50517],
    [90.923876, 23.505394],
    [90.919641, 23.504934],
    [90.907539, 23.506122],
    [90.895704, 23.505451],
    [90.883887, 23.505854],
    [90.879657, 23.507593],
    [90.868234, 23.514298],
    [90.861672, 23.516888],
    [90.852672, 23.517028],
    [90.849342, 23.518445],
    [90.846332, 23.521111],
    [90.844431, 23.522127],
    [90.812494, 23.530722],
    [90.793798, 23.530489],
    [90.786168, 23.531484],
    [90.782913, 23.530582],
    [90.757239, 23.529767],
    [90.738278, 23.528483],
    [90.734845, 23.528965],
    [90.725583, 23.533244],
    [90.723885, 23.533569],
    [90.717925, 23.531508],
    [90.7132, 23.530889],
    [90.691497, 23.52953],
    [90.689499, 23.529776],
    [90.649288, 23.564616],
    [90.640639, 23.579829],
    [90.627084, 23.593902],
    [90.622519, 23.597677],
    [90.616407, 23.601005],
    [90.611615, 23.610672],
    [90.611002, 23.614665],
    [90.608704, 23.619203],
    [90.601617, 23.630179],
    [90.594571, 23.636047],
    [90.588546, 23.647133],
    [90.564307, 23.662415],
    [90.553198, 23.683293],
    [90.546616, 23.690369],
    [90.539202, 23.693039],
    [90.525257, 23.704105],
    [90.522567, 23.705553],
    [90.5199, 23.705111],
    [90.512267, 23.699008],
    [90.509595, 23.697825],
    [90.51265, 23.693124],
    [90.51843, 23.673485],
    [90.516455, 23.668225],
    [90.512268, 23.66],
    [90.511342, 23.653271],
    [90.51382, 23.646209],
    [90.5105, 23.637925],
    [90.51138, 23.636323],
    [90.504902, 23.630907],
    [90.497809, 23.627793],
    [90.497371, 23.626822],
    [90.49934, 23.624046],
    [90.500067, 23.623882],
    [90.49845, 23.62405],
    [90.499398, 23.622291],
    [90.499907, 23.619653],
    [90.50104, 23.619771],
    [90.500621, 23.622437],
    [90.496664, 23.627804],
    [90.4935, 23.644619],
    [90.489467, 23.65523],
    [90.482443, 23.676502],
    [90.481933, 23.684737],
    [90.48058, 23.692593],
    [90.479198, 23.693424],
    [90.474039, 23.692995],
    [90.46975, 23.693522],
    [90.474679, 23.693167],
    [90.485748, 23.694467],
    [90.485814, 23.694863],
    [90.488271, 23.695153],
    [90.488284, 23.69658],
    [90.487792, 23.697096],
    [90.486909, 23.697099],
    [90.485764, 23.69693],
    [90.487792, 23.697096],
    [90.487883, 23.6966],
    [90.490493, 23.696291],
    [90.490257, 23.695024],
    [90.49272, 23.695366],
    [90.475507, 23.693083],
    [90.46982, 23.693411],
    [90.435316, 23.709739],
    [90.428594, 23.712055],
    [90.428239, 23.712797],
    [90.429218, 23.716585],
    [90.428953, 23.71968],
    [90.428478, 23.719608],
    [90.428339, 23.720359],
    [90.427372, 23.720387],
    [90.427163, 23.718515],
    [90.426187, 23.716592],
  ],

  // DHK-FENI-02: Abdullahpur → Feni
  "9c8bc5b3-abe7-43fd-914c-d530ff11fd55": [
    [90.374786, 23.835034],
    [90.376343, 23.835146],
    [90.376082, 23.837048],
    [90.374646, 23.838151],
    [90.374288, 23.837716],
    [90.375821, 23.837406],
    [90.376382, 23.836647],
    [90.376783, 23.830371],
    [90.378, 23.823069],
    [90.380357, 23.823462],
    [90.38451, 23.820805],
    [90.388287, 23.820042],
    [90.390138, 23.820367],
    [90.393394, 23.822685],
    [90.395514, 23.820358],
    [90.397189, 23.820911],
    [90.397076, 23.82187],
    [90.399253, 23.822325],
    [90.40032, 23.819428],
    [90.401731, 23.819831],
    [90.402205, 23.818434],
    [90.400394, 23.817904],
    [90.400323, 23.813793],
    [90.399392, 23.810708],
    [90.403417, 23.811066],
    [90.404452, 23.815294],
    [90.405765, 23.816697],
    [90.407117, 23.817072],
    [90.411786, 23.81702],
    [90.419003, 23.821695],
    [90.420205, 23.823682],
    [90.420417, 23.8258],
    [90.417892, 23.838441],
    [90.415186, 23.842386],
    [90.404896, 23.854789],
    [90.400646, 23.852051],
    [90.400311, 23.852478],
    [90.399413, 23.851979],
    [90.398311, 23.85213],
    [90.396763, 23.851091],
    [90.395594, 23.851664],
    [90.393981, 23.853401],
    [90.391881, 23.853548],
    [90.393981, 23.853401],
    [90.395594, 23.851664],
    [90.396763, 23.851091],
    [90.398311, 23.85213],
    [90.399413, 23.851979],
    [90.400311, 23.852478],
    [90.400646, 23.852051],
    [90.404872, 23.854818],
    [90.400846, 23.859548],
    [90.400617, 23.860381],
    [90.416581, 23.841057],
    [90.418746, 23.836245],
    [90.420674, 23.825648],
    [90.421449, 23.824583],
    [90.421139, 23.821799],
    [90.420285, 23.820216],
    [90.421111, 23.817863],
    [90.421455, 23.808762],
    [90.425409, 23.787824],
    [90.425861, 23.783284],
    [90.426961, 23.783108],
    [90.427744, 23.7835],
    [90.428337, 23.783114],
    [90.428548, 23.782003],
    [90.427347, 23.781956],
    [90.427362, 23.781248],
    [90.427371, 23.782],
    [90.428571, 23.781948],
    [90.427742, 23.779655],
    [90.427962, 23.778968],
    [90.430676, 23.778359],
    [90.430753, 23.777254],
    [90.432001, 23.777181],
    [90.432639, 23.775481],
    [90.432087, 23.775397],
    [90.431824, 23.774551],
    [90.432032, 23.775333],
    [90.426267, 23.775633],
    [90.425388, 23.771657],
    [90.423105, 23.767633],
    [90.432941, 23.763326],
    [90.442738, 23.762184],
    [90.442555, 23.760473],
    [90.441746, 23.760517],
    [90.441042, 23.753888],
    [90.438418, 23.753519],
    [90.43842, 23.752768],
    [90.437551, 23.752458],
    [90.43842, 23.752768],
    [90.438722, 23.749802],
    [90.439206, 23.749774],
    [90.439526, 23.748388],
    [90.443761, 23.745844],
    [90.443834, 23.744877],
    [90.445448, 23.744834],
    [90.446309, 23.744289],
    [90.447107, 23.740921],
    [90.447887, 23.740919],
    [90.449017, 23.740022],
    [90.449375, 23.737462],
    [90.453937, 23.737699],
    [90.45689, 23.738542],
    [90.460407, 23.730558],
    [90.461209, 23.724294],
    [90.468613, 23.717594],
    [90.470504, 23.706677],
    [90.476467, 23.709456],
    [90.477435, 23.70789],
    [90.478351, 23.707849],
    [90.479033, 23.701192],
    [90.480954, 23.694289],
    [90.483736, 23.694223],
    [90.506823, 23.696942],
    [90.512299, 23.699211],
    [90.519843, 23.705243],
    [90.521952, 23.705815],
    [90.524212, 23.705057],
    [90.53924, 23.693112],
    [90.546668, 23.690461],
    [90.553288, 23.683373],
    [90.564702, 23.66214],
    [90.588651, 23.647157],
    [90.594687, 23.636152],
    [90.601587, 23.630349],
    [90.608868, 23.619162],
    [90.609451, 23.617362],
    [90.611013, 23.615127],
    [90.61163, 23.611149],
    [90.616652, 23.600954],
    [90.622318, 23.597943],
    [90.626758, 23.594296],
    [90.640826, 23.579777],
    [90.649381, 23.564727],
    [90.689022, 23.530095],
    [90.691505, 23.529685],
    [90.71575, 23.531321],
    [90.72408, 23.533705],
    [90.725375, 23.533511],
    [90.732536, 23.530049],
    [90.736668, 23.528667],
    [90.779879, 23.530831],
    [90.786164, 23.531609],
    [90.793374, 23.530601],
    [90.802216, 23.530755],
    [90.806934, 23.53109],
    [90.827197, 23.534962],
    [90.831936, 23.533247],
    [90.845131, 23.522144],
    [90.858589, 23.518197],
    [90.867453, 23.514799],
    [90.879382, 23.507888],
    [90.883645, 23.50601],
    [90.89444, 23.50559],
    [90.907622, 23.506266],
    [90.919675, 23.505049],
    [90.923372, 23.505517],
    [90.931407, 23.505216],
    [90.950063, 23.50095],
    [90.963591, 23.499719],
    [90.981809, 23.495577],
    [91.000088, 23.489474],
    [91.009341, 23.489899],
    [91.017343, 23.487139],
    [91.026747, 23.482717],
    [91.032449, 23.482677],
    [91.035999, 23.481013],
    [91.037777, 23.480736],
    [91.046386, 23.482036],
    [91.053916, 23.482138],
    [91.059049, 23.48151],
    [91.059144, 23.484476],
    [91.059858, 23.48624],
    [91.059146, 23.487199],
    [91.059265, 23.490771],
    [91.060547, 23.493395],
    [91.060195, 23.49491],
    [91.060785, 23.495174],
    [91.06107, 23.499689],
    [91.061391, 23.500465],
    [91.062624, 23.500418],
    [91.062964, 23.502459],
    [91.063495, 23.503035],
    [91.063532, 23.506476],
    [91.064239, 23.509072],
    [91.063352, 23.509369],
    [91.063453, 23.511642],
    [91.062452, 23.513214],
    [91.061246, 23.514096],
    [91.062196, 23.521894],
    [91.053999, 23.522722],
    [91.052931, 23.523094],
    [91.050374, 23.525682],
    [91.05053, 23.526757],
    [91.052549, 23.528244],
    [91.061272, 23.529179],
    [91.06136, 23.526377],
    [91.062229, 23.525769],
    [91.0623, 23.524705],
    [91.061246, 23.514096],
    [91.062452, 23.513214],
    [91.063453, 23.511642],
    [91.063352, 23.509369],
    [91.064239, 23.509072],
    [91.063532, 23.506476],
    [91.063495, 23.503035],
    [91.062964, 23.502459],
    [91.062624, 23.500418],
    [91.061391, 23.500465],
    [91.06107, 23.499689],
    [91.060785, 23.495174],
    [91.060195, 23.49491],
    [91.060547, 23.493395],
    [91.059265, 23.490771],
    [91.059146, 23.487199],
    [91.059858, 23.48624],
    [91.059144, 23.484476],
    [91.059049, 23.48151],
    [91.068398, 23.481296],
    [91.074243, 23.477553],
    [91.07586, 23.477142],
    [91.08516, 23.476825],
    [91.090861, 23.478499],
    [91.094352, 23.477785],
    [91.099793, 23.477588],
    [91.112939, 23.478917],
    [91.121721, 23.478974],
    [91.1279, 23.480146],
    [91.134174, 23.478254],
    [91.136105, 23.477139],
    [91.136208, 23.476787],
    [91.134199, 23.478079],
    [91.128457, 23.479978],
    [91.128381, 23.47711],
    [91.129256, 23.476169],
    [91.128527, 23.471846],
    [91.126576, 23.470312],
    [91.1264, 23.468753],
    [91.12259, 23.467959],
    [91.124217, 23.461529],
    [91.126442, 23.457385],
    [91.12943, 23.456623],
    [91.131989, 23.457432],
    [91.134692, 23.45743],
    [91.137002, 23.458627],
    [91.142358, 23.458918],
    [91.148108, 23.446932],
    [91.155686, 23.42807],
    [91.157535, 23.426114],
    [91.183265, 23.413425],
    [91.208824, 23.410058],
    [91.211328, 23.409244],
    [91.213045, 23.408077],
    [91.224989, 23.396631],
    [91.240349, 23.377948],
    [91.250025, 23.364069],
    [91.256038, 23.353755],
    [91.264912, 23.341639],
    [91.273717, 23.331887],
    [91.283031, 23.318442],
    [91.286623, 23.30803],
    [91.290185, 23.301157],
    [91.292051, 23.29283],
    [91.294989, 23.284604],
    [91.295976, 23.283074],
    [91.299777, 23.279758],
    [91.306283, 23.266201],
    [91.307979, 23.253132],
    [91.313037, 23.239641],
    [91.313217, 23.231252],
    [91.314267, 23.2259],
    [91.314267, 23.219746],
    [91.315995, 23.213599],
    [91.319485, 23.191279],
    [91.319159, 23.191099],
    [91.316948, 23.193581],
    [91.315673, 23.193719],
    [91.304082, 23.192731],
    [91.301829, 23.193183],
    [91.300289, 23.192677],
    [91.296332, 23.188539],
    [91.295747, 23.18718],
    [91.291741, 23.186745],
    [91.284373, 23.187071],
    [91.284327, 23.185991],
    [91.280921, 23.185919],
    [91.280688, 23.185093],
    [91.279512, 23.184243],
    [91.276021, 23.185045],
    [91.270725, 23.185427],
    [91.270521, 23.184596],
    [91.26928, 23.18389],
    [91.273763, 23.183552],
    [91.274267, 23.185009],
    [91.275844, 23.185065],
    [91.282901, 23.183077],
    [91.283111, 23.17873],
    [91.282723, 23.176436],
    [91.283928, 23.175189],
    [91.282328, 23.170749],
    [91.282584, 23.169026],
    [91.281884, 23.167777],
    [91.290885, 23.168344],
    [91.296569, 23.166326],
    [91.299785, 23.166496],
    [91.313073, 23.167929],
    [91.314046, 23.167628],
    [91.321181, 23.167954],
    [91.321261, 23.17044],
    [91.321853, 23.158757],
    [91.326613, 23.14753],
    [91.32628, 23.13833],
    [91.327794, 23.131376],
    [91.33317, 23.118995],
    [91.359691, 23.072706],
    [91.361658, 23.065844],
    [91.361813, 23.060809],
    [91.365137, 23.048143],
    [91.365832, 23.034584],
    [91.365455, 23.02554],
    [91.366009, 23.023345],
    [91.367374, 23.021469],
    [91.381561, 23.009517],
    [91.37648, 23.009786],
    [91.376373, 23.007523],
    [91.377162, 23.006592],
    [91.377578, 23.004596],
    [91.380411, 23.004882],
    [91.380512, 23.003507],
    [91.381193, 23.00353],
    [91.382472, 23.002234],
    [91.383133, 22.997348],
    [91.386889, 22.997502],
    [91.389145, 22.998587],
    [91.392279, 22.99883],
    [91.393209, 23.000908],
    [91.390749, 23.002594],
    [91.394273, 23.002582],
    [91.394432, 23.007169],
    [91.39526, 23.007248],
    [91.394964, 23.009424],
    [91.399302, 23.009679],
    [91.393377, 23.01538],
    [91.394095, 23.016011],
    [91.397581, 23.016677],
    [91.397468, 23.015876],
  ],

  // FENI-DHK-02: Feni → Abdullahpur
  "9d53e16f-bdfa-446d-82f8-09c3e62ccbba": [
    [91.397468, 23.015876],
    [91.397581, 23.016677],
    [91.396066, 23.016314],
    [91.39628, 23.015035],
    [91.395023, 23.01401],
    [91.399033, 23.010175],
    [91.403648, 23.003773],
    [91.40831, 22.991178],
    [91.406805, 22.991039],
    [91.409314, 22.988442],
    [91.403251, 22.994049],
    [91.393432, 23.000772],
    [91.393466, 22.998795],
    [91.383089, 22.997373],
    [91.382472, 23.002234],
    [91.380512, 23.003507],
    [91.382279, 23.00841],
    [91.381103, 23.00951],
    [91.373411, 23.009878],
    [91.369539, 23.00916],
    [91.371748, 23.012453],
    [91.370146, 23.016654],
    [91.370487, 23.018695],
    [91.366948, 23.021727],
    [91.365377, 23.024826],
    [91.364842, 23.04918],
    [91.358265, 23.074343],
    [91.333035, 23.118975],
    [91.32764, 23.131347],
    [91.321575, 23.159424],
    [91.32105, 23.170415],
    [91.319793, 23.176923],
    [91.320551, 23.18466],
    [91.318815, 23.191664],
    [91.316948, 23.193581],
    [91.315673, 23.193719],
    [91.301829, 23.193183],
    [91.300289, 23.192677],
    [91.295747, 23.18718],
    [91.284373, 23.187071],
    [91.284327, 23.185991],
    [91.280921, 23.185919],
    [91.279512, 23.184243],
    [91.270725, 23.185427],
    [91.26928, 23.18389],
    [91.273763, 23.183552],
    [91.274267, 23.185009],
    [91.275683, 23.185071],
    [91.279512, 23.184243],
    [91.280921, 23.185919],
    [91.284327, 23.185991],
    [91.284373, 23.187071],
    [91.295747, 23.18718],
    [91.300289, 23.192677],
    [91.301829, 23.193183],
    [91.316948, 23.193581],
    [91.315823, 23.213663],
    [91.313713, 23.221406],
    [91.312802, 23.240023],
    [91.306678, 23.255857],
    [91.298259, 23.270952],
    [91.290239, 23.300625],
    [91.286743, 23.307417],
    [91.282324, 23.319415],
    [91.273515, 23.331927],
    [91.264914, 23.341441],
    [91.255692, 23.354007],
    [91.250215, 23.363539],
    [91.240245, 23.377868],
    [91.228524, 23.392123],
    [91.212777, 23.408111],
    [91.208888, 23.409913],
    [91.182701, 23.413482],
    [91.156298, 23.426959],
    [91.141976, 23.459503],
    [91.13702, 23.475448],
    [91.135622, 23.477324],
    [91.128457, 23.479978],
    [91.128381, 23.47711],
    [91.129256, 23.476169],
    [91.128527, 23.471846],
    [91.129513, 23.472064],
    [91.130449, 23.474898],
    [91.132714, 23.477157],
    [91.132662, 23.478621],
    [91.128457, 23.479978],
    [91.121907, 23.478865],
    [91.082323, 23.476738],
    [91.075287, 23.477077],
    [91.068964, 23.479353],
    [91.053282, 23.482021],
    [91.059049, 23.48151],
    [91.059858, 23.48624],
    [91.059146, 23.487199],
    [91.059265, 23.490771],
    [91.060547, 23.493395],
    [91.06107, 23.499689],
    [91.062624, 23.500418],
    [91.063495, 23.503035],
    [91.064239, 23.509072],
    [91.063352, 23.509369],
    [91.063453, 23.511642],
    [91.061246, 23.514096],
    [91.062128, 23.522098],
    [91.052972, 23.523068],
    [91.050374, 23.525682],
    [91.050486, 23.526688],
    [91.052549, 23.528244],
    [91.061272, 23.529179],
    [91.0623, 23.524705],
    [91.061246, 23.514096],
    [91.063453, 23.511642],
    [91.063352, 23.509369],
    [91.064239, 23.509072],
    [91.063495, 23.503035],
    [91.062624, 23.500418],
    [91.06107, 23.499689],
    [91.060547, 23.493395],
    [91.059265, 23.490771],
    [91.059146, 23.487199],
    [91.059858, 23.48624],
    [91.059049, 23.48151],
    [91.068398, 23.481296],
    [91.074243, 23.477553],
    [91.077022, 23.476967],
    [91.068964, 23.479353],
    [91.054273, 23.481981],
    [91.044642, 23.48178],
    [91.037845, 23.480584],
    [91.032211, 23.482482],
    [91.027384, 23.482396],
    [91.0093, 23.489785],
    [90.999937, 23.489381],
    [90.981342, 23.495544],
    [90.975574, 23.494158],
    [90.962497, 23.499703],
    [90.95411, 23.49952],
    [90.930936, 23.50517],
    [90.919641, 23.504934],
    [90.907539, 23.506122],
    [90.883887, 23.505854],
    [90.868234, 23.514298],
    [90.861672, 23.516888],
    [90.852672, 23.517028],
    [90.844431, 23.522127],
    [90.812494, 23.530722],
    [90.793798, 23.530489],
    [90.786168, 23.531484],
    [90.782913, 23.530582],
    [90.738278, 23.528483],
    [90.734845, 23.528965],
    [90.723885, 23.533569],
    [90.7132, 23.530889],
    [90.689499, 23.529776],
    [90.649288, 23.564616],
    [90.640639, 23.579829],
    [90.627084, 23.593902],
    [90.622519, 23.597677],
    [90.616407, 23.601005],
    [90.611615, 23.610672],
    [90.611002, 23.614665],
    [90.608704, 23.619203],
    [90.601617, 23.630179],
    [90.594571, 23.636047],
    [90.588546, 23.647133],
    [90.564307, 23.662415],
    [90.553198, 23.683293],
    [90.546616, 23.690369],
    [90.539202, 23.693039],
    [90.524126, 23.704953],
    [90.522105, 23.705601],
    [90.519518, 23.70487],
    [90.511747, 23.698801],
    [90.506821, 23.69685],
    [90.475507, 23.693083],
    [90.469791, 23.693442],
    [90.470764, 23.694523],
    [90.470267, 23.698193],
    [90.469177, 23.702115],
    [90.467824, 23.702276],
    [90.470504, 23.706677],
    [90.476467, 23.709456],
    [90.474586, 23.716998],
    [90.468751, 23.716344],
    [90.467808, 23.71854],
    [90.461209, 23.724294],
    [90.460407, 23.730558],
    [90.45689, 23.738542],
    [90.449375, 23.737462],
    [90.449017, 23.740022],
    [90.447107, 23.740921],
    [90.446309, 23.744289],
    [90.443834, 23.744877],
    [90.443761, 23.745844],
    [90.439526, 23.748388],
    [90.43842, 23.752768],
    [90.437551, 23.752458],
    [90.438418, 23.753519],
    [90.441042, 23.753888],
    [90.441746, 23.760517],
    [90.442555, 23.760473],
    [90.442738, 23.762184],
    [90.433605, 23.763149],
    [90.423542, 23.767251],
    [90.421986, 23.766352],
    [90.425371, 23.771997],
    [90.425663, 23.776714],
    [90.425824, 23.773803],
    [90.430148, 23.773348],
    [90.430826, 23.775289],
    [90.432032, 23.775333],
    [90.431824, 23.774551],
    [90.432639, 23.775481],
    [90.430676, 23.778359],
    [90.427962, 23.778968],
    [90.428548, 23.782003],
    [90.427347, 23.781956],
    [90.427362, 23.781248],
    [90.427371, 23.782],
    [90.428548, 23.782003],
    [90.428379, 23.780694],
    [90.425672, 23.780551],
    [90.425552, 23.779743],
    [90.425589, 23.780584],
    [90.421723, 23.780795],
    [90.409347, 23.780243],
    [90.398577, 23.780885],
    [90.403556, 23.810335],
    [90.40529, 23.81232],
    [90.415259, 23.818676],
    [90.420587, 23.82038],
    [90.422272, 23.823672],
    [90.418364, 23.839111],
    [90.404896, 23.854789],
    [90.400646, 23.852051],
    [90.398311, 23.85213],
    [90.396763, 23.851091],
    [90.393981, 23.853401],
    [90.391881, 23.853548],
    [90.393981, 23.853401],
    [90.396763, 23.851091],
    [90.398311, 23.85213],
    [90.400646, 23.852051],
    [90.404872, 23.854818],
    [90.400617, 23.860381],
    [90.417951, 23.838635],
    [90.420582, 23.825382],
    [90.419089, 23.82162],
    [90.412026, 23.816985],
    [90.407279, 23.816933],
    [90.405886, 23.815601],
    [90.398371, 23.816912],
    [90.393304, 23.82257],
    [90.395514, 23.820358],
    [90.397189, 23.820911],
    [90.397076, 23.82187],
    [90.399253, 23.822325],
    [90.40032, 23.819428],
    [90.401731, 23.819831],
    [90.402205, 23.818434],
    [90.400394, 23.817904],
    [90.400281, 23.816337],
    [90.398161, 23.816999],
    [90.393367, 23.822471],
    [90.389714, 23.820094],
    [90.384578, 23.820658],
    [90.380421, 23.823365],
    [90.377699, 23.823184],
    [90.376343, 23.835146],
    [90.374786, 23.835034],
  ],

  // CTG-CXB: Chattogram → Cox's Bazar
  "4dbb14d5-3130-4989-af0f-e2b64ff267c9": [
    [91.812308, 22.347505],
    [91.812449, 22.34566],
    [91.814013, 22.344393],
    [91.813307, 22.343958],
    [91.818828, 22.339861],
    [91.820352, 22.33841],
    [91.820608, 22.337206],
    [91.829503, 22.335454],
    [91.831, 22.334289],
    [91.834943, 22.333425],
    [91.838182, 22.333454],
    [91.840036, 22.334221],
    [91.840055, 22.33338],
    [91.843509, 22.332913],
    [91.844791, 22.330859],
    [91.847642, 22.330596],
    [91.851586, 22.331827],
    [91.853172, 22.325918],
    [91.853702, 22.318922],
    [91.856009, 22.312766],
    [91.857239, 22.310464],
    [91.865351, 22.30043],
    [91.867403, 22.294673],
    [91.870094, 22.291392],
    [91.883935, 22.297955],
    [91.910543, 22.305376],
    [91.922041, 22.315434],
    [91.923657, 22.315935],
    [91.933337, 22.313572],
    [91.93698, 22.314316],
    [91.94447, 22.313516],
    [91.946236, 22.31249],
    [91.94887, 22.307788],
    [91.949375, 22.303418],
    [91.964889, 22.301118],
    [91.976419, 22.29721],
    [91.980455, 22.295289],
    [91.981139, 22.29382],
    [91.982136, 22.293305],
    [91.983121, 22.290791],
    [91.980762, 22.290283],
    [91.98353, 22.29127],
    [91.988192, 22.287843],
    [91.995474, 22.284453],
    [92.003222, 22.279025],
    [92.005432, 22.274184],
    [92.006068, 22.264562],
    [92.009412, 22.255962],
    [92.016726, 22.247972],
    [92.018364, 22.24527],
    [92.020657, 22.24472],
    [92.021353, 22.24373],
    [92.021687, 22.239032],
    [92.023246, 22.23683],
    [92.025087, 22.23109],
    [92.027214, 22.223481],
    [92.028473, 22.215255],
    [92.036179, 22.206506],
    [92.040828, 22.203752],
    [92.042027, 22.202415],
    [92.041948, 22.200848],
    [92.044059, 22.196399],
    [92.045641, 22.190083],
    [92.048169, 22.188503],
    [92.048997, 22.186517],
    [92.050581, 22.184862],
    [92.052531, 22.1763],
    [92.055832, 22.176691],
    [92.056055, 22.175938],
    [92.059193, 22.175223],
    [92.066728, 22.176629],
    [92.06646, 22.179442],
    [92.070354, 22.179914],
    [92.070801, 22.182543],
    [92.074654, 22.183121],
    [92.075142, 22.184112],
    [92.07486, 22.185918],
    [92.077564, 22.187115],
    [92.077654, 22.188082],
    [92.077564, 22.187115],
    [92.07486, 22.185918],
    [92.075142, 22.184112],
    [92.074654, 22.183121],
    [92.070801, 22.182543],
    [92.070354, 22.179914],
    [92.06646, 22.179442],
    [92.066728, 22.176629],
    [92.059193, 22.175223],
    [92.056055, 22.175938],
    [92.055832, 22.176691],
    [92.052531, 22.1763],
    [92.053504, 22.173334],
    [92.053354, 22.16755],
    [92.054473, 22.165328],
    [92.063446, 22.163405],
    [92.065515, 22.162087],
    [92.071364, 22.154746],
    [92.069674, 22.151128],
    [92.070153, 22.132154],
    [92.074702, 22.098107],
    [92.093371, 22.083739],
    [92.098613, 22.080814],
    [92.100098, 22.075243],
    [92.103514, 22.070182],
    [92.106568, 22.06736],
    [92.10735, 22.06185],
    [92.108952, 22.057574],
    [92.109266, 22.053443],
    [92.108012, 22.045453],
    [92.105014, 22.042307],
    [92.104041, 22.040153],
    [92.104356, 22.03049],
    [92.102613, 22.027114],
    [92.10279, 22.023563],
    [92.102124, 22.021776],
    [92.101207, 22.020218],
    [92.097073, 22.017739],
    [92.094566, 22.014918],
    [92.094583, 22.010342],
    [92.087805, 21.999408],
    [92.087907, 21.996786],
    [92.085638, 21.989706],
    [92.082113, 21.983177],
    [92.07895, 21.980334],
    [92.074897, 21.978979],
    [92.07239, 21.976257],
    [92.069111, 21.975855],
    [92.067162, 21.973079],
    [92.065336, 21.971713],
    [92.062696, 21.966334],
    [92.062481, 21.963646],
    [92.063255, 21.962019],
    [92.06783, 21.956343],
    [92.06831, 21.954609],
    [92.067034, 21.945181],
    [92.059481, 21.930083],
    [92.058564, 21.923843],
    [92.059468, 21.921546],
    [92.060516, 21.914546],
    [92.060373, 21.90906],
    [92.061363, 21.902086],
    [92.060832, 21.90049],
    [92.061054, 21.895929],
    [92.059443, 21.891997],
    [92.060121, 21.888579],
    [92.058933, 21.880712],
    [92.05942, 21.877769],
    [92.058778, 21.867051],
    [92.060716, 21.858496],
    [92.060948, 21.849785],
    [92.062332, 21.847248],
    [92.062375, 21.844978],
    [92.064741, 21.841206],
    [92.065432, 21.83886],
    [92.066933, 21.83758],
    [92.069848, 21.83005],
    [92.071711, 21.827364],
    [92.074064, 21.820833],
    [92.0739, 21.815849],
    [92.077844, 21.811396],
    [92.077996, 21.808585],
    [92.077136, 21.803834],
    [92.07774, 21.801056],
    [92.077423, 21.798487],
    [92.078942, 21.791851],
    [92.078605, 21.789477],
    [92.07927, 21.782842],
    [92.083712, 21.778723],
    [92.085018, 21.776129],
    [92.084959, 21.774967],
    [92.082461, 21.77173],
    [92.07623, 21.765941],
    [92.075857, 21.763359],
    [92.076509, 21.75964],
    [92.07445, 21.758887],
    [92.073028, 21.757445],
    [92.066795, 21.757245],
    [92.066226, 21.758063],
    [92.064705, 21.758064],
    [92.064046, 21.758725],
    [92.060078, 21.758909],
    [92.056984, 21.758236],
    [92.053492, 21.755628],
    [92.047561, 21.752503],
    [92.038155, 21.749459],
    [92.037759, 21.748805],
    [92.03913, 21.74865],
    [92.04001, 21.74566],
    [92.041426, 21.743448],
    [92.034927, 21.738301],
    [92.03557, 21.733916],
    [92.033189, 21.733251],
    [92.032502, 21.732092],
    [92.034433, 21.730069],
    [92.035484, 21.729969],
    [92.039957, 21.731803],
    [92.042113, 21.731708],
    [92.044173, 21.733363],
    [92.048891, 21.732119],
    [92.048894, 21.726486],
    [92.045074, 21.723496],
    [92.042499, 21.724134],
    [92.042092, 21.7281],
    [92.040225, 21.730154],
    [92.040375, 21.731629],
    [92.037292, 21.730652],
    [92.03691, 21.726272],
    [92.037682, 21.722654],
    [92.03677, 21.722245],
    [92.037173, 21.719597],
    [92.038789, 21.719982],
    [92.044282, 21.717271],
    [92.051191, 21.716534],
    [92.052286, 21.714939],
    [92.05199, 21.712885],
    [92.048248, 21.711952],
    [92.047587, 21.711271],
    [92.046986, 21.708879],
    [92.044003, 21.704433],
    [92.04484, 21.703576],
    [92.047007, 21.703257],
    [92.049604, 21.701801],
    [92.051771, 21.699269],
    [92.053686, 21.698866],
    [92.055912, 21.701562],
    [92.05823, 21.702041],
    [92.058864, 21.702714],
    [92.06242, 21.702861],
    [92.063973, 21.703559],
    [92.067889, 21.700414],
    [92.073879, 21.70168],
    [92.076139, 21.701475],
    [92.07705, 21.700533],
    [92.078507, 21.700274],
    [92.080378, 21.697765],
    [92.081123, 21.691369],
    [92.079867, 21.684517],
    [92.077142, 21.679125],
    [92.076566, 21.67181],
    [92.074847, 21.664005],
    [92.075178, 21.658285],
    [92.073325, 21.649768],
    [92.073227, 21.64131],
    [92.076936, 21.635847],
    [92.076733, 21.631399],
    [92.077596, 21.626472],
    [92.076781, 21.624897],
    [92.068538, 21.618023],
    [92.061948, 21.606028],
    [92.061282, 21.592769],
    [92.062822, 21.590804],
    [92.063006, 21.588946],
    [92.065131, 21.587295],
    [92.064967, 21.585662],
    [92.066883, 21.578963],
    [92.069254, 21.577584],
    [92.070798, 21.575694],
    [92.071844, 21.572005],
    [92.070612, 21.568704],
    [92.070134, 21.563283],
    [92.067616, 21.554194],
    [92.066799, 21.5462],
    [92.064527, 21.542697],
    [92.063846, 21.540114],
    [92.065211, 21.525764],
    [92.066088, 21.520923],
    [92.071307, 21.508995],
    [92.075044, 21.504482],
    [92.075071, 21.50024],
    [92.079972, 21.491059],
    [92.081794, 21.490215],
    [92.08498, 21.490024],
    [92.087295, 21.487453],
    [92.09089, 21.486257],
    [92.094015, 21.479204],
    [92.102081, 21.468574],
    [92.103185, 21.462416],
    [92.105732, 21.459585],
    [92.103468, 21.456051],
    [92.101146, 21.454946],
    [92.099761, 21.452568],
    [92.099475, 21.449797],
    [92.101474, 21.443369],
    [92.098314, 21.437117],
    [92.095307, 21.428641],
    [92.078155, 21.426524],
    [92.07331, 21.42672],
    [92.066537, 21.428876],
    [92.062725, 21.427062],
    [92.054278, 21.428199],
    [92.049121, 21.427429],
    [92.045026, 21.429384],
    [92.042407, 21.429688],
    [92.037485, 21.429837],
    [92.033361, 21.428702],
    [92.029459, 21.430487],
    [92.028148, 21.430058],
    [92.021796, 21.425083],
    [92.013674, 21.424654],
    [92.005267, 21.427418],
    [92.001881, 21.429739],
    [91.995205, 21.438368],
    [91.988915, 21.440471],
    [91.989412, 21.445355],
    [91.987433, 21.445381],
    [91.987061, 21.446458],
    [91.982791, 21.448211],
    [91.982265, 21.449164],
  ],
};

export const ROUTE_META: Record<string, { routeCode: string; routeName: string; acFare: number; nonAcFare: number; durationMin: number }> = {
  "1c1892af-325c-4fc7-9223-cc6575b2aae9": { routeCode: "DHK-FENI-01", routeName: "Dhaka (Maniknagar) → Feni",      acFare: 450, nonAcFare: 380, durationMin: 300 },
  "fd5c5ad4-10a5-4174-b1d0-921dcec0770e": { routeCode: "FENI-DHK-01", routeName: "Feni → Dhaka (Maniknagar)",      acFare: 450, nonAcFare: 380, durationMin: 300 },
  "9c8bc5b3-abe7-43fd-914c-d530ff11fd55": { routeCode: "DHK-FENI-02", routeName: "Dhaka (Abdullahpur) → Feni",     acFare: 500, nonAcFare: 450, durationMin: 330 },
  "9d53e16f-bdfa-446d-82f8-09c3e62ccbba": { routeCode: "FENI-DHK-02", routeName: "Feni → Dhaka (Abdullahpur)",     acFare: 500, nonAcFare: 450, durationMin: 330 },
  "4dbb14d5-3130-4989-af0f-e2b64ff267c9": { routeCode: "CTG-CXB",     routeName: "Chattogram → Cox's Bazar",      acFare: 600, nonAcFare: 600, durationMin: 210 },
};

export const BANGLADESH_CENTER: [number, number] = [90.3563, 23.6850];
export const BANGLADESH_ZOOM = 7;
export const ROUTE_ZOOM = 8;
export const BUS_ZOOM = 13;

export function getRoutePolyline(routeId: string): [number, number][] {
  return ROUTE_POLYLINES[routeId] ?? [];
}
export function getTerminalCoords(terminalId: string) {
  return TERMINAL_COORDS[terminalId] ?? null;
}
export function getRouteMidpoint(routeId: string): [number, number] {
  const pts = ROUTE_POLYLINES[routeId];
  if (!pts?.length) return BANGLADESH_CENTER;
  return pts[Math.floor(pts.length / 2)];
}
